/**
 * 消息已读取状态枚举
 */
export var EMessageReadStatus = /*#__PURE__*/function (EMessageReadStatus) {
  EMessageReadStatus[EMessageReadStatus["READ"] = 1] = "READ";
  EMessageReadStatus[EMessageReadStatus["UNREAD"] = 2] = "UNREAD";
  EMessageReadStatus[EMessageReadStatus["ALL_READ"] = 3] = "ALL_READ";
  EMessageReadStatus[EMessageReadStatus["ALL"] = 99] = "ALL";
  return EMessageReadStatus;
}({});

/**
 * 未读tab信息
 */

// 系统名称

/**
 * 订阅消息类型
 */

// message PopupsConfigBO {
//     string h5_image_url = 1; // H5弹窗图片地址
//     string h5_jump_url = 2; // h5跳转链接
//     string h5_text = 3; // h5文案
//     string app_image_url = 4; // 移动端弹窗图片地址
//     string app_jump_url = 5; // app跳转链接
//     string app_text = 6; // app文案
//     string pc_image_url = 7; // PC弹窗图片地址
//     string pc_jump_url = 8; // pc端跳转链接
//     string pc_text = 9; // pc端文案
//     uint32 window_type = 10; // 1, "纯文本弹窗" 2, "纯图片弹窗" 3, "图文格式弹窗"
// }